import React, { useState } from 'react';

const ThemeEditor = ({ initialCustomTheme, onSave, onCancel }) => {
  const [colors, setColors] = useState({
    bgPrimary: initialCustomTheme?.bgPrimary || '#18181b',
    bgSecondary: initialCustomTheme?.bgSecondary || '#27272a',
    bgTertiary: initialCustomTheme?.bgTertiary || '#09090b',
    blurple: initialCustomTheme?.blurple || '#8b5cf6',
    textNormal: initialCustomTheme?.textNormal || '#fafafa',
    textMuted: initialCustomTheme?.textMuted || '#a1a1aa'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setColors(prev => ({ ...prev, [name]: value }));
  };

  const handleApply = () => {
    onSave(colors);
  };

  const renderInput = (label, name) => (
    <div className="form-group">
      <label className="input-label">{label}</label>
      <div className="color-input-wrapper">
        <div style={{
          width: '38px',
          height: '38px',
          borderRadius: '4px',
          background: colors[name],
          border: '1px solid var(--border-subtle)',
          flexShrink: 0
        }} />
        <input 
          type="text" 
          name={name} 
          value={colors[name]} 
          onChange={handleChange} 
          className="input-field hex-input" 
          placeholder="#HEX, rgb(), or linear-gradient()"
        />
      </div>
    </div>
  );

  return (
    <div className="modal-overlay">
      <div className="modal-card" style={{ width: '560px' }}>
        <h2>Custom Theme Builder</h2>
        <p>Use hex, rgb, or gradients (e.g. <code>linear-gradient(45deg, #f06, #9f6)</code>).</p>

        <div className="theme-editor-grid">
          {renderInput('Main Background', 'bgPrimary')}
          {renderInput('Sidebar Background', 'bgSecondary')}
          {renderInput('Deep Background (Inputs)', 'bgTertiary')}
          {renderInput('Accent Color (Buttons)', 'blurple')}
          {renderInput('Primary Text', 'textNormal')}
          {renderInput('Muted Text', 'textMuted')}
        </div>

        <div className="modal-actions" style={{ marginTop: '24px' }}>
          <button className="btn btn-gray" onClick={onCancel}>Cancel</button>
          <button className="btn btn-blurple" onClick={handleApply}>Save Custom Theme</button>
        </div>
      </div>
    </div>
  );
};

export default ThemeEditor;
